<template>
  <div class="payment">
    <v-subheader>Payment Information</v-subheader>
    <v-card flat>
    <v-container v-if="payment">
      <v-simple-table>
        <tr><th>Order ID</th><td>{{ payment.order_id }}</td></tr>
        <tr><th>Invoice Number</th><td>{{ payment.invoice_number }}</td></tr>
        <tr><th>Total Bill</th><td>Rp. {{ payment.total_bill.toLocaleString('id-ID') }}</td></tr>
      </v-simple-table>
    </v-container>
    </v-card>

    <v-subheader>Transfer To</v-subheader>
    <v-card flat>
    <v-container>
      <v-simple-table>
        <tr>
            <td><img src="img/bca.png"></td>
            <td>BCA: No Rek. 1980050757</td>
            <td>Atas nama: Junaedi Harmiansyah</td>
        </tr>
        <!-- <tr>
            <td><img src="img/mandiri.png"></td>
            <td>BANK MANDIRI KCP xyz No Rek 456</td>
        </tr> -->
      </v-simple-table>
    </v-container>
    </v-card>

    <v-subheader></v-subheader>
    <div class="text-center">
    <v-dialog
      v-model="dialog"
      width="500"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
         color="primary"
          dark
          v-bind="attrs"
          v-on="on"
        >
         Payment Instructions
        </v-btn>
      </template>

      <v-card>
        <v-card-title class="text-h5 blue">
          Payment Instructions
        </v-card-title>

        <v-card-text>
          1. Transfer according to the account number listed above. 
          2. Upload proof of transfer, for confirmation in your order screen .
          3. Whattsapp confirm.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialog = false"
          >
            I accept
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
    <v-subheader></v-subheader>
    
    <v-layout row wrap>
      <v-flex xs12 text-center>
      <v-btn color="success" @click="finish"  elevation="24" x-large>
          Finish
      </v-btn>
      </v-flex>
    </v-layout>
   
  </div>
</template>
<script>

  import { mapGetters, mapActions } from 'vuex'
  export default {
    computed: {
      ...mapGetters({
        payment  : 'payment',
      }),
    },
    created(){
        if(this.payment==undefined){
            this.setAlert({
                status : true,
                text  : 'Payment undefined',
                color  : 'warning',
            })
            this.$router.push('/')
        }
    },
    methods: {
        ...mapActions({
            setAlert      : 'alert/set',
        }),
        finish(){
            this.setAlert({
                status : true,
                text  : 'Transaction done',
                color  : 'success',
            })
            this.$router.push('/')
        }
    },
     data () {
      return {
        dialog: false,
      }
    },
  }
</script>